import { atom } from 'recoil';

import { ExtendedProject } from '../../../types/ExtendedProject';

export const projectAtom = atom<ExtendedProject | null>({
  key: 'projectAtom',
  default: null,
});

export const projectLoadingAtom = atom<boolean>({
  key: 'projectLoadingAtom',
  default: true,
});
